<div class="container mx-auto p-8">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4 class="!text-[24px] !font-semibold !text-[#203D54]">Contractors</h4>
    <!-- Contractors Section -->

    <!-- Contractors Section -->
    <div class="section-color mb-8 p-6">
      <h2 class="text-xl section-title mb-4">Contractors</h2>
      <div class="mb-4">
        <label for="contractorTitle" class="block section-label-sm"
          >Title</label
        >
        <input
          type="text"
          id="contractorTitle"
          formControlName="contractorTitle"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Title"
        />
        <div
          *ngIf="
            form.get('contractorTitle')?.touched &&
            form.get('contractorTitle')?.invalid
          "
        >
          <span
            *ngIf="form.get('contractorTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
          >
            Title is required
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label for="contractorDescription" class="block section-label-sm"
          >Description</label
        >

        <textarea
          id="contractorDescription"
          formControlName="contractorDescription"
          rows="6"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Description"
        ></textarea>
      </div>
      <div class="mb-4">
        <label for="contractorFile" class="block section-label-sm"
          >Attach Documents</label
        >
        <input
          type="file"
          id="contractorFile"
          (change)="onFileUpload($event)"
          class="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md cursor-pointer focus:outline-none"
        />
        <div *ngIf="showFileError" class="text-red-500 text-sm">
          File is required.
        </div>
      </div>

      <div class="mb-4">
        <label for="email" class="block section-label-sm">Email</label>
        <input
          type="text"
          id="email"
          formControlName="email"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Your Email"
        />
      </div>
      <div class="mb-4">
        <label for="phone" class="block section-label-sm">Phone Number</label>
        <input
          type="text"
          id="phone"
          formControlName="phone"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Your PhoneNumber"
        />
      </div>
      <div class="mb-4">
        <label for="address" class="block section-label-sm">Address</label>
        <input
          type="text"
          id="address"
          formControlName="address"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Address"
        />
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end">
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
      >
        Back
      </button>
      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
      >
        Save
      </button>
    </div>
  </form>
</div>
